import React, { useEffect, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";

const AcceptModal = ({ confirmLabel = "Reject", onClose, onSubmit }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
    }, []);

    const handleSubmit = async () => {
        setSubmitting(true);
        await onSubmit?.();
        setSubmitting(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content kyc-verify-modal">
                    <div className="modal-header align-items-center justify-content-between">
                        <h5 className="mb-0">Confimation</h5>
                        <button type="button" className="kyc-verify-modal-close" data-bs-dismiss="modal" aria-label="Close" disabled={submitting}>
                            <FaTimes />
                        </button>
                    </div>
                    <div className="modal-body p-0">
                        <div className="kyc-verify-modal-body">
                            <span>Activate this customer account?</span>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" disabled={submitting}>Cancel</button>
                        <button type="button" className="btn btn-success" onClick={handleSubmit} disabled={submitting}>
                            {submitting ? "Submitting..." : confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcceptModal;
